// ─── Constants ────────────────────────────────────────────────────────────────

export const PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

export const STATUS_OPTIONS = ['all', 'processing', 'completed', 'failed', 'retrying'];

export const EVENT_TYPE_OPTIONS = [
  'all',
  // Stripe event types (dot notation)
  'checkout.session.completed',
  'checkout.session.expired',
  'customer.created',
  'customer.updated',
  'customer.deleted',
  'customer.subscription.created',
  'customer.subscription.updated',
  'customer.subscription.deleted',
  'customer.subscription.paused',
  'customer.subscription.resumed',
  'invoice.created',
  'invoice.finalized',
  'invoice.paid',
  'invoice.payment_succeeded',
  'invoice.payment_failed',
  'invoice.upcoming',
  'invoice.voided',
  'payment_intent.created',
  'payment_intent.succeeded',
  'payment_intent.payment_failed',
  'payment_intent.canceled',
  'price.created',
  'price.updated',
  'price.deleted',
  'product.created',
  'product.updated',
  'product.deleted',
  'charge.succeeded',
  'charge.failed',
  'charge.refunded',
  // Internal event types
  'checkout_initiated',
  'subscribed',
  'renewed',
  'upgraded',
  'downgraded',
  'payment_succeeded',
  'payment_failed',
  'renewal_failed',
  'cancelled',
  'suspended',
  'refund_requested',
  'refund_approved',
  'refund_rejected',
];

export const ERROR_CATEGORY_LABELS = {
  timeout: 'Timeout',
  validation_error: 'Validation Error',
  client_error: '4xx Client Error',
  server_error: '5xx Server Error',
  network_error: 'Network Error',
};

export const DEFAULT_FILTERS = {
  from: '',
  to: '',
  eventType: 'all',
  status: 'all',
  subscriptionPlanName: '',
};

// ─── Formatters ───────────────────────────────────────────────────────────────

export const fmtDate = (iso) => {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone: 'UTC',
    timeZoneName: 'short',
  });
};

export const statusBadge = (status) => {
  const map = {
    pending:    'bg-[#FEFCE8] text-[#CA8A04] border border-[#FEF08A]',
    processing: 'bg-[#EFF6FF] text-[#2563EB] border border-[#BFDBFE]',
    completed:  'bg-[#F0FDF4] text-[#16A34A] border border-[#BBF7D0]',
    failed:     'bg-[#FFF1F2] text-[#E11D48] border border-[#FECDD3]',
    retrying:   'bg-[#FFF7ED] text-[#EA580C] border border-[#FED7AA]',
  };
  return map[status] || 'bg-[#F1F5F9] text-[#64748B] border border-[#E2E8F0]';
};

export const httpCodeColor = (code) => {
  if (!code) return 'text-[#94A3B8]';
  if (code >= 500) return 'text-[#E11D48]';
  if (code >= 400) return 'text-[#EA580C]';
  if (code >= 200 && code < 300) return 'text-[#16A34A]';
  return 'text-[#64748B]';
};

// ─── CSV Export (safe fields only) ───────────────────────────────────────────

export const exportToCsv = (rows) => {
  const SAFE_HEADERS = [
    'Subscription Plan',
    'Plan ID',
    'Event ID',
    'Event Type',
    'Webhook Endpoint',
    'Time (UTC)',
    'Status',
    'HTTP Status Code',
    'Retry Count',
    'Duration (ms)',
    'Error Category',
  ];

  const lines = [
    SAFE_HEADERS.join(','),
    ...rows.map((r) =>
      [
        r.subscriptionPlanName,
        r.subscriptionPlanId,
        r.eventId,
        r.eventType,
        r.webhookEndpoint,
        r.receivedAt ? new Date(r.receivedAt).toISOString() : '',
        r.status,
        r.httpStatusCode,
        r.retryCount,
        r.durationMs,
        r.errorCategory,
      ]
        .map((v) => (v == null ? '""' : `"${String(v).replace(/"/g, '""')}"`))
        .join(',')
    ),
  ];

  const blob = new Blob([lines.join('\n')], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `webhook-logs-${Date.now()}.csv`;
  a.click();
  URL.revokeObjectURL(url);
};
